module.exports = __webpack_public_path__ + "img/watermark.69a4507a.png";